import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useSessionTimeout from '../hooks/useSessionTimeout';

/**
 * SessionManager component - Manages session timeout globally
 * This component doesn't render anything but handles session timeout logic
 */
const SessionManager = () => {
  const location = useLocation();
  const { resetTimer } = useSessionTimeout();

  // Reset timer on route change (when user navigates to a new page)
  useEffect(() => {
    const userRole = localStorage.getItem('userRole');
    if (userRole && location?.pathname !== '/login') {
      resetTimer();
    }
  }, [location?.pathname, resetTimer]);

  // This component doesn't render anything
  return null;
};

export default SessionManager;